const registry = require('../registry');

/**
 * @type {import('../registry').ExtractAccessFunction}
 */
function extractAccess(_hNode, options) {
    const { roles } = options;
    const { customizableVisibility, formAction } = _hNode;

    let spec = [];
    let access = {};
    // unless explicitly specified, we _only_ care about delete and copy buttons.
    // all other buttons e.g. cancel and refresh we would never want to limit
    // and the save is handled elsewhere (through the + button)
    if (!customizableVisibility && !['delete', 'remove', 'copy', 'submit'].includes(formAction)) {
        return { spec, access };
    }

    // Generate a more useful title that is a bit more descriptive...
    let hNode = { ..._hNode };
    // Generate a more useful title that is a bit more descriptive...
    if (hNode.title.toUpperCase() === 'SAVE') {
        hNode.title = 'UPDATE a record';
    } else {
        hNode.title = `${hNode.title.toUpperCase()} a record`;
    }

    // But for the formButtons with the given forActions, always add them to the spec and access:
    spec = registry.addSpec(spec, hNode, {});
    access = registry.addAccess(access, hNode, { roles });

    //don't care about children. formButtons don't have any.

    return { spec, access };
}
const formButtons = {
    FormButton: { extractAccess }
};
registry.register('formButtons', formButtons);
module.exports = formButtons;
